import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { TextArea } from 'app/shared/input/textarea';
import { useDemoService } from 'hooks/users/demo';
import { toast } from 'react-toastify';
import { InfoBanner } from 'app/shared/info-banner';
import { Spacer } from 'app/layouts/generic';

export const ContactSales = () => {
  const {
    firstname,
    email: userEmail,
    lastname,
    tenant_id
  } = useSelector((state) => state.user_data);
  const { bookMeeting } = useDemoService();

  const [email, setEmail] = useState(userEmail || '');
  const [has_requested, setHasRequested] = useState(false);
  const [is_saving, setSaving] = useState(false);
  const [phone_number, setPhoneNumber] = useState('');
  const [meeting_date, setMeetingDate] = useState('');
  const [meeting_time, setMeetingTime] = useState('');
  const [additional_info, setAdditionalInfo] = useState('');

  const submit = async () => {
    const data = {
      type: 'pricing_call',
      metadata: {
        firstname,
        lastname,
        email,
        tenant_id,
        phone_number,
        meeting_date,
        meeting_time,
        additional_info
      }
    };

    setSaving(true);
    const result = await bookMeeting({ data });
    setSaving(false);
    if (!result) return;

    setHasRequested(true);
    toast.success('Meeting request submitted successfully. Our team will be in touch soon.');
  };

  return has_requested ? (
    <div>
      Thanks! We've received your request and will confirm your meeting time within 24 hours. Check
      your inbox at {email}.
    </div>
  ) : (
    <div>
      <GridRow num_of_columns={2} mobileStyles={{ gap: '5px' }}>
        <GridColumn>
          <DetailItem title="Email Address">
            <SimpleInput placeholder="Enter your email address" value={email} onChange={setEmail} />
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Phone Number">
            <SimpleInput
              placeholder="Enter your phone number"
              value={phone_number}
              onInput={setPhoneNumber}
            />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={2} mobileStyles={{ gap: '5px' }}>
        <GridColumn>
          <DetailItem title="Preferred Meeting Date">
            <SimpleInput
              placeholder="Select a date for the meeting"
              value={meeting_date}
              onInput={setMeetingDate}
              type="date"
            />
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Preferred Meeting Time">
            <SimpleInput
              placeholder="Select a time for the meeting"
              value={meeting_time}
              onInput={setMeetingTime}
              type="time"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Additional Information">
            <TextArea
              placeholder="Any specific topics or questions you would like to discuss?"
              value={additional_info}
              onInput={setAdditionalInfo}
            />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <InfoBanner
            message={
              <p>
                Need to talk sooner? Email us directly at{' '}
                <a href="mailto:sales@go-mailer.com">sales@go-mailer.com</a> and we'll respond
                within 2 hours.
              </p>
            }
          />
        </GridColumn>
      </GridRow>
      <Spacer multiple={4} />
      <GridRow num_of_columns={3} mobileStyles={{ gap: '5px' }}>
        <GridColumn span={2} />
        <GridColumn>
          <Button
            text="Request Meeting"
            onClick={submit}
            loading={is_saving}
            disabled={is_saving}
          />
        </GridColumn>
      </GridRow>
    </div>
  );
};
